import { graphql } from "./generated/gql";

export const MyInterviewsQuery = graphql(`
  query MyInterviews {
    myInterviews {
      nodes {
        interviewId
        candidateId
        candidateName
        candidateNameKana
        candidateEmail
        termId
        termTitle
        termNotionUrl
        sponsorId
        sponsorName
        startTime
        endTime
        zoomMeetingUrl
        zoomMeetingStartUrl
        zoomRecordingViewUrl
        stakeholderContext {
          recipientNames
          answersImported
        }
        status
        summaryCheckCompletedAt
        completionReport {
          completionReportId
          interviewId
          handoverNote
          coachReportNg
          interviewerInsight
          internalUseAllowed
          hasConfidentialInfo
          confidentialInfo
          satisfactionScore
          behaviorChangeScore
          completedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const MyInterviewQuery = graphql(`
  query MyInterview($interviewId: ID!) {
    myInterview(interviewId: $interviewId) {
      interviewId
      candidateId
      candidateName
      candidateNameKana
      candidateEmail
      termId
      termTitle
      termNotionUrl
      sponsorId
      sponsorName
      startTime
      endTime
      zoomMeetingUrl
      zoomMeetingStartUrl
      zoomRecordingViewUrl
      stakeholderContext {
        stakeholderSettingName
        recipientNames
        answersImported
      }
      status
      rawVttText
      summaryCheckCompletedAt
      completionReport {
        completionReportId
        interviewId
        handoverNote
        coachReportNg
        interviewerInsight
        internalUseAllowed
        hasConfidentialInfo
        confidentialInfo
        satisfactionScore
        behaviorChangeScore
        completedAt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`);

export const InterviewScriptQuery = graphql(`
  query InterviewScript($interviewId: ID!) {
    interviewScript(interviewId: $interviewId) {
      nodes {
        scriptItemId
        scriptId
        category
        timeEstimate
        itemName
        isRequired
        question
        answer
        memo
        note
        order
        orderIndex
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const EnsureInterviewScriptMutation = graphql(`
  mutation EnsureInterviewScript($interviewId: ID!) {
    ensureInterviewScript(interviewId: $interviewId) {
      nodes {
        scriptItemId
        scriptId
        category
        timeEstimate
        itemName
        isRequired
        question
        answer
        memo
        note
        order
        orderIndex
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const UpdateMyScriptItemMutation = graphql(`
  mutation UpdateMyScriptItem($input: UpdateMyScriptItemInput!) {
    updateMyScriptItem(input: $input) {
      scriptItemId
      scriptId
      category
      timeEstimate
      itemName
      isRequired
      question
      answer
      memo
      note
      order
      orderIndex
      createdAt
      updatedAt
    }
  }
`);

export const CompleteMyInterviewMutation = graphql(`
  mutation CompleteMyInterview($input: CompleteInterviewInput!) {
    completeMyInterview(input: $input) {
      success
      interviewId
      errorMessage
    }
  }
`);

export const UpdateMyInterviewStatusMutation = graphql(`
  mutation UpdateMyInterviewStatus($interviewId: ID!, $status: String!) {
    updateMyInterviewStatus(interviewId: $interviewId, status: $status) {
      interviewId
      candidateId
      candidateName
      startTime
      endTime
      zoomMeetingUrl
      zoomMeetingStartUrl
      status
      createdAt
      updatedAt
    }
  }
`);

export const UseCasesQuery = graphql(`
  query UseCases {
    useCases {
      nodes {
        useCaseId
        category
        cognitiveAction
        name
      }
      totalCount
    }
  }
`);

export const SelfInterviewSummaryItemsQuery = graphql(`
  query SelfInterviewSummaryItems($interviewId: ID!) {
    interviewSummaryItems(interviewId: $interviewId) {
      nodes {
        summaryItemId
        interviewId
        category
        content
        useCaseId
        order
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const UpdateSummaryItemMutation = graphql(`
  mutation UpdateSummaryItem($input: UpdateSummaryItemInput!) {
    updateSummaryItem(input: $input) {
      summaryItemId
      interviewId
      category
      content
      useCaseId
      order
      createdAt
      updatedAt
    }
  }
`);

export const BulkSaveSummaryItemsMutation = graphql(`
  mutation BulkSaveSummaryItems($input: BulkSaveSummaryItemsInput!) {
    bulkSaveSummaryItems(input: $input) {
      success
      items {
        summaryItemId
        interviewId
        category
        content
        useCaseId
        order
        createdAt
        updatedAt
      }
      errorMessage
    }
  }
`);

export const CompleteSummaryCheckMutation = graphql(`
  mutation CompleteSummaryCheck($input: CompleteSummaryCheckInput!) {
    completeSummaryCheck(input: $input) {
      success
      interviewId
      status
      summaryCheckCompletedAt
      errorMessage
    }
  }
`);

export const BulkSaveMyScriptItemsMutation = graphql(`
  mutation BulkSaveMyScriptItems($input: BulkSaveScriptItemsInput!) {
    bulkSaveMyScriptItems(input: $input) {
      success
      items {
        scriptItemId
        scriptId
        category
        timeEstimate
        itemName
        isRequired
        question
        answer
        memo
        note
        order
        orderIndex
        createdAt
        updatedAt
      }
      errorMessage
    }
  }
`);
